module.exports = __webpack_public_path__ + "img/05d482f6b9e0778093379feef1d64393.png";